/* @flow */
import getDocument from '@loggi/js/get-document';

export function clean(value: string) {
  if (!value) {
    return '';
  }

  return decodeURIComponent(value.replace(/\"/gi, '').trim());
}

export default function getCookies() {
  const document = getDocument();
  if (document === null) {
    return {};
  }

  return (document.cookie || '').split(';').reduce((obj, item) => {
    if (item) {
      const [key, value] = item.split('=');
      obj[clean(key)] = clean(value);
    }
    return obj;
  }, {});
}
